<template>
  <div class="flex rounded-full bg-white pl-4">
    <label class="flex items-center   flex-1 min-w-0">
      <i class="el-icon-search text-xl text-gray-500  font-bold" />
      <el-input v-model="val" class="rounded-full" :placeholder="placeholder" size="normal" />
    </label>
    <el-button class="btn-primary" round size="default" @click="search">Search</el-button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },

    placeholder: {
      type: String,
      default: 'Search Keyword'
    }
  },

  data() {
    return {
      val: ''
    }
  },

  watch: {
    value: {
      handler(val) {
        this.val = val
      },
      immediate: true
    }
  },

  methods: {
    search() {
      this.$emit('input', this.val)
      this.$emit('search', this.val)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep  .el-input__inner{
    border: none;
}
</style>
